export const alertSensorMap: Record<string, string> = {
  IMU: 'IMU',
  frontCamera: 'FC',
  inwardCamera: 'IC',
  cloud: 'CL',
};
